import { render, staticRenderFns } from "./PurchaseOrders.vue?vue&type=template&id=69154a07&scoped=true"
import script from "./PurchaseOrders.vue?vue&type=script&lang=js"
export * from "./PurchaseOrders.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrders.vue?vue&type=style&index=0&id=69154a07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69154a07",
  null
  
)

export default component.exports